module.exports = __webpack_public_path__ + "img/transition_crm_logo.a858c4d8.png";